import React from 'react';
import { Inbox } from 'lucide-react';

const EmptyState = ({ icon: Icon = Inbox, title, message, action }) => (
    <div className="text-center py-20">
        <div className="w-20 h-20 bg-white/50 dark:bg-white/[0.05] backdrop-blur-sm border border-white/40 dark:border-white/[0.08] rounded-2xl flex items-center justify-center mx-auto mb-6">
            <Icon className="w-8 h-8 text-slate-400 dark:text-slate-500" />
        </div>
        <h3 className="text-xl font-semibold text-slate-900 dark:text-white mb-2">{title}</h3>
        {message && <p className="text-slate-500 dark:text-slate-400">{message}</p>}
        {action && <div className="mt-6">{action}</div>}
    </div>
);

export default EmptyState;
